<!-- PIE CHART GENERIC COMPONENT  -->
<template>
    <div class="chart mb-3 card h-100" :class="classes">
        <div :id="id" class="card-body">
            <div v-if="type == 'commissions'">
                <div class="row">
                    <div class="col">
                        <p class="mb-2 fw500 text-muted">{{ title }} (USD)</p>
                    </div>
                    <div class="col-auto">
                        <div class="avatar">
                            <div class="avatar-title"> <i class="fa fa-dollar-sign"></i> </div>
                        </div>
                    </div>
                </div>

                <p class="fw400 mt-1 mb-3 text-xtra-big counter" :data-total="total">0</p>
                <div v-if="list">
                    <div class=" mb-3 float-right" type="button" data-toggle="collapse" :data-target="`#${id}_collapse`" aria-expanded="false" :aria-controls="`${id}_collapse`">
                        <i class="fa fa-eye" :style="{color:'#23bfcb'}" aria-hidden="true"></i>
                    </div>
                
                    <div class="collapse" :id="`${id}_collapse`">
                        <div class="card card-body">
                            <table class="table table-striped">
                                <!-- <thead>
                                    <tr>
                                        <th scope="col">Folio</th>
                                        <th scope="col"></th>
                                        <th scope="col"></th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead> -->
                                <tbody>
                                    <tr v-for="(item, key) in list" :key="key">
                                        
                                            <!-- <th scope="row">
                                                {{item.id}}
                                            </th> -->
                                            <th scope="row">
                                                <small> {{item.public_folio}} </small>
                                            </th>
                                            <th >
                                                <small> {{new Date(item.created_at).getDate()}}-{{new Date(item.created_at).getMonth()+1}}-{{new Date(item.created_at).getFullYear()}} </small>
                                            </th>
                                            <th>
                                                <small> {{item.name}} {{item.last_name}} </small>
                                            </th>
                                            <th >
                                                <small> ${{item.total}} </small>
                                            </th>
                                        
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="type =='percentage'">
                <div class="row">
                    <div class="col">
                        <p class="mb-2 fw500 text-muted">{{ title }} %</p>
                    </div>
                    <div class="col-auto">
                        <div class="avatar">
                            <div class="avatar-title"> <i class="fa fa-percentage"></i> </div>
                        </div>
                    </div>
                </div>

                <p class="fw400 mt-1 mb-3 text-xtra-big counter" :data-total="total">0</p>
            </div>

            <div v-else-if="type =='cards'">
                <div class="row">
                    <div class="col">
                        <p class="mb-2 fw500 text-muted">{{ title }}</p>
                    </div>
                    <div class="col-auto">
                        <div class="avatar">
                            <div class="avatar-title"> <i class="fas fa-address-card"></i> </div>
                        </div>
                    </div>
                </div>

                <p class="fw400 mt-1 mb-3 text-xtra-big counter" :data-total="total">0</p>

                <div class="mb-0">
                    <span class="fw400 text-danger" v-if="message != null">{{ subtotal }}</span>
                    <span class="fw400 text-muted text-sm">{{ message }}</span>
                </div>
            </div>
            <div v-else-if="type =='gift'">
                <div class="row">
                    <div class="col">
                        <p class="mb-2 fw500 text-muted">{{ title }}</p>
                    </div>
                    <div class="col-auto">
                        <div class="avatar">
                            <div class="avatar-title"> <i class="fas fa-gift"></i> </div>
                        </div>
                    </div>
                </div>

                <p class="fw400 mt-1 mb-3 text-xtra-big counter" :data-total="total">0</p>

                <div class="mb-0">
                    <span class="fw400 text-danger" v-if="message != null">{{ subtotal }}</span>
                    <span class="fw400 text-muted text-sm">{{ message }}</span>
                </div>
            </div>
            <div v-else-if="type =='camera'">
                <div class="row">
                    <div class="col">
                        <p class="mb-2 fw500 text-muted">{{ title }}</p>
                    </div>
                    <div class="col-auto">
                        <div class="avatar">
                            <div class="avatar-title"> <i class="fas fa-camera"></i> </div>
                        </div>
                    </div>
                </div>

                <p class="fw400 mt-1 mb-3 text-xtra-big counter" :data-total="total">0</p>

                <div class="mb-0">
                    <span class="fw400 text-danger" v-if="message != null">{{ subtotal }}</span>
                    <span class="fw400 text-muted text-sm">{{ message }}</span>
                </div>
            </div>
            <div v-else-if="type =='copy'">
                <div class="row">
                    <div class="col">
                        <p class="mb-2 fw500 text-muted">{{ title }}</p>
                    </div>
                    <div class="col-auto">
                        <div class="avatar">
                            <div class="avatar-title"> <i class="fas fa-copy"></i> </div>
                        </div>
                    </div>
                </div>

                <p class="fw400 mt-1 mb-3 text-xtra-big counter" :data-total="total">0</p>

                <div class="mb-0">
                    <span class="fw400 text-danger" v-if="message != null">{{ subtotal }}</span>
                    <span class="fw400 text-muted text-sm">{{ message }}</span>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col">
                        <p class="mb-2 fw500 text-muted">{{ title }}</p>
                    </div>
                    <div class="col-auto">
                        <div class="avatar">
                            <div class="avatar-title"> <i class="fa fa-users"></i> </div>
                        </div>
                    </div>
                </div>

                <p class="fw400 mt-1 mb-3 text-xtra-big counter" :data-total="total">0</p>

                <div class="mb-0" v-if="plan == null">
                    <span class="fw400 text-danger" v-if="message != null">{{ subtotal }} {{ plan }}</span>
                    <span class="fw400 text-muted text-sm">{{ message }}</span>
                </div>
                <div class="mb-0" v-else>
                    <span class="fw400 text-danger" v-if="message != null">{{ plan }}</span>
                    <span class="fw400 text-muted text-sm" v-if="planid != 1">{{ message }} {{ expires }}</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    export default {
        props: ['id', 'total', 'title', 'classes', 'subtotal', 'message', 'type', 'plan', 'expires', 'planid'],
        data() {
            return {
                dates: null
            }
        },
        mounted() {
            console.log('line chart componente mounted');
            var id       = this.id;
            var total    = this.total;
            var type     = this.type;

            //Animate Number
            function animateNumber(input) {
                setTimeout(() => {

                    var counter = 0
                    var primary = setInterval(() => {

                        if (counter <= total) {

                            if (type == 'commissions') {
                                $('#'+id+' .counter').html('$'+ number_format(counter,2,'.',','));
                            } else {
                                $('#'+id+' .counter').html(counter);
                            }

                            if (counter >= 2) {

                                var secondary = setInterval(() => {
                                    if (counter <= total) {
                                        if (type == 'commissions') {
                                            $('#'+id+' .counter').html('$'+ number_format(counter,2,'.',','));
                                        } else {
                                            $('#'+id+' .counter').html(counter);
                                        }
                                        counter++;
                                    } else {
                                        //$('#'+id+'.counter').css('color', 'black');
                                        clearInterval(secondary);
                                    }
                                }, 1);
                            }
                            counter++;
                        } else {
                            clearInterval(primary);
                        }
                    }, 300)
                }, 300)
            }

            animateNumber();

            $(document).on('change', '#start-date', function (event) {
            })
        },
    }
</script>
